module.exports = __webpack_public_path__ + "static/media/arrow-up-grey-solid.a9701593.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up-grey-solid.svg
// module id = 679
// module chunks = 0